import { atom } from 'jotai';

/**
 * 処理完了メッセージ、エラーメッセージ
 */
export type NoticeMessageStateType = {
  message: string | null;
  status: 'success' | 'warning' | 'failure' | null;
};

export const NoticeMessageState = atom<NoticeMessageStateType>({ message: null, status: null });
